<!--
 * @Author:
 * @Description:二维码支付，公共页面
 * @Date: 2024-10-22 09:50:48
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/views/payment/local-qris.vue
-->
<template>
  <div ref="local" id="local" class="local-wrapper">
    <!-- 全屏加载遮罩 -->
    <div v-loading.fullscreen="fullscreenLoading" style="height: 100%;">
    <!-- 主要内容区域 -->
    <div class="payment-container" v-if="paymentInfo">
      <!-- 暂时去掉倒计时 -->
      <!-- <div class="OnCountdownTimer" v-if="isMobile">
          <OnCountdownTimer style="margin-bottom: 24px;" :merchantTxnTime="paymentInfo.presentContext.expirationDate"
           :effectiveMinutes="720" />
        </div> -->
      <!-- 左侧订单信息区域 -->
      <div class="left-section">
        <OrderInfoVue :order="paymentInfo" :isQr="true"  :isMobile="isMobile" v-if="!isMobile"/>
        <orderSummary v-else :orderGetter="paymentInfo" :viewTxnId="paymentInfo.merchantTxnId" class="order-summary" ref="orderSummaryRef"  :isQr="true"/>
      </div>
      <!-- 右侧支付信息区域 -->
      <div class="right-section">
        <!-- 倒计时--暂时去掉 -->
        <!-- <div class="OnCountdownTimer" v-if="!isMobile">
          <OnCountdownTimer style="margin-bottom: 24px;" :merchantTxnTime="paymentInfo.presentContext.expirationDate"
           :effectiveMinutes="720" />
        </div> -->
      <div class="content">
          <!-- 支付方式标识 -->
          <div class="payment-method">
            <div class="payment-method-label">{{ $t('message.checkout.paymentMethod') }}</div>
            <img
              v-if="paymentInfo.checkoutModelResp && paymentInfo.checkoutModelResp.base64Logo"
              :src="`data:image/png;base64,${paymentInfo.checkoutModelResp.base64Logo}`"
              alt="Payment Method"
              class="payment-logo"
            />
        </div>
        <div class="validity-section">
          <!-- scanQrCode -->
          <div class="scan-title"> {{ $t('message.QR.scanQrCode') }}</div>
          <div class="validity-badge">
            <i class="el-icon-warning-outline"></i>
            {{ $t('message.QR.validFor24h') }}
          </div>
        </div>
        <!-- 二维码扫描区域 -->
        <div class="qr-section">
          <div class='warning-info'>{{ $t('message.QR.scanQrCodeOrDownload') }}</div>
          <div class="ticket-item"  v-if="paymentInfo.presentContext.pixCopyAndPaste">
            <div class="ticket">{{ paymentInfo.presentContext.pixCopyAndPaste }}</div>
            <el-button class="button" type="text" @click="copyTicket">
              <span class="iconfont icon-rongqi"></span>
            </el-button>
          </div>
          <!-- 二维码图片 -->
          <div class="qr-code-container" v-if="paymentInfo.presentContext && paymentInfo.presentContext.base64Image">
            <img
              :src="`data:image/png;base64,${paymentInfo.presentContext.base64Image}`"
              alt="QR Code"
              class="qr-code-image"
            />
          </div>
          <!-- 下载按钮 -->
          <button class="download-btn" @click="downloadQrCode">
            {{ $t('message.QR.downloadQr') }}
            <img class="icon-down" src="@/assets/images/icon-down.png" alt="Download QR" >
          </button>
        </div>
      </div>
      </div>
    </div>
  </div>
  <!-- 错误----pc -->
  <Modal v-if="!isMobile" :modelValue="errorModalInfo.modelValue"
      :title="errorModalInfo.title"
      :description="errorModalInfo.description"
      :status="errorModalInfo.status"
      :buttonText="errorModalInfo.buttonText"
      :redirectUrl="errorModalInfo.redirectUrl"
    />
    <Modal v-if="!isMobile"  :modelValue="successModalInfo.modelValue"
      :title="successModalInfo.title"
      :description="successModalInfo.description"
      :status="successModalInfo.status"
      :buttonText="successModalInfo.buttonText"
      :redirectUrl="successModalInfo.redirectUrl"
      :billingAddress="successModalInfo.billingAddress"
    />

    <!-- popupBottom--移动端支付成功失败的结果 -->
    <popupBottom v-if="isMobile" :open="resultPopup.visible" :redirectUrl="resultPopup.redirectUrl"
      :popupStatus="resultPopup.popupStatus" :popupTitle="resultPopup.popupTitle" :popupText="resultPopup.popupText"
      :billingAddress="resultPopup.billingAddress">
    </popupBottom>
 </div>
</template>
<script>
import FileSaver from 'file-saver';
import { toBlob } from 'html-to-image';

import { getStatus, getLocalPaymentInfo } from '@/api/checkout';
import orderSummary from '@/components/orderSummary/index.vue';
import popupBottom from '@/components/popupBottom/index.vue';
// import OnCountdownTimer from '@/componentsV2/busi/countdown-timer/index.vue';
import Modal from '@/componentsV2/busi/Modal/Modal.vue';
import { formatMoneyWithCommasQr } from '@/utils/tools/format';
import { copyString } from '@/utils/tools/utils';

import OrderInfoVue from '../../componentsV2/busi/OrderInfo/OrderInfo.vue';

export default {
  components: {
    OrderInfoVue,
    // OnCountdownTimer,
    orderSummary,
    Modal,
    popupBottom,
  },
  data() {
    return {
      fullscreenLoading: true,
      txnId: '',
      paymentInfo: null,
      showErrorMsg: false,
      showCardName: false,
      pollingTimer: null,
      pollingCount: 0,
      maxPollingTime: 15 * 60 * 1000, // 15分钟
      pollingStartTime: null,
      isPollingActive: false,
      errorModalInfo: {
        modelValue: false,
        title: this.$t('message.result.failed'),
        description: this.$t('message.result.failedPop'),
        status: 'error',
        buttonText: this.$t('message.checkout.returnMerchant'),
        redirectUrl: '',
      },
      successModalInfo: {
        modelValue: false,
        title: this.$t('message.result.success'),
        description: this.$t('message.result.successPop'),
        status: 'success',
        buttonText: this.$t('message.checkout.returnMerchant'),
        redirectUrl: '',
        billingAddress: '',
      },
      resultPopup: {
        visible: false,
        popupStatus: '',
        popupTitle: '',
        popupText: '',
        redirectUrl: '',
        billingAddress: '',
      },
    };
  },
  created() {
    this.txnId = this.$route.query.txnId;
    getLocalPaymentInfo(this.txnId).then((res) => {
      this.fullscreenLoading = false;
      if (res.respCode === '20000') {
        this.paymentInfo = res.data;
        if (res.data.brandConfig) {
          this.$store.dispatch('app/setBrandInfo', res.data.brandConfig);
        }
        if (!res.data) {
          this.showErrorMsg = true;
        } else {
          this.startPolling();
        }
      } else {
        this.showErrorMsg = true;
      }
    }).catch(() => {
      this.showErrorMsg = true;
      this.fullscreenLoading = false;
    });
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    formatMoneyWithCommasQr,
    copyTicket() {
      copyString(this.paymentInfo.presentContext.pixCopyAndPaste);
    },
    download() {
      toBlob(this.$refs.local)
        .then(() => {
          // Fix Safari 会显示图片失败，使用再次绘制处理
          toBlob(this.$refs.local)
            .then((blob) => {
              console.log(blob, 'blob');

              if (window.saveAs) {
                window.saveAs(blob, 'payment_code.jpg');
              } else {
                FileSaver.saveAs(blob, 'payment_code.jpg');
              }
            }).catch((error) => {
              console.log('download page error', error);
            });
        }).catch((error) => {
          console.log('download page error', error);
        });
    },
    // 直接下载二维码图片
    downloadQrCode() {
      if (this.paymentInfo && this.paymentInfo.presentContext && this.paymentInfo.presentContext.base64Image) {
        // 将base64转换为Blob对象
        const byteString = atob(this.paymentInfo.presentContext.base64Image);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: 'image/png' });

        // 使用FileSaver保存图片
        if (window.saveAs) {
          window.saveAs(blob, 'payment_code.png');
        } else {
          FileSaver.saveAs(blob, 'payment_code.png');
        }
      }
    },
    startPolling() {
      if (this.isPollingActive) return;
      this.isPollingActive = true;
      this.pollingStartTime = Date.now();
      this.pollingCount = 0;
      this.queryPaymentStatus();
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
      this.isPollingActive = false;
    },
    getPollingInterval() {
      if (this.pollingCount <= 5) {
        return 2000; // 2秒
      } else if (this.pollingCount <= 15) {
        return 5000; // 5秒
      } else if (this.pollingCount <= 30) {
        return 10000; // 10秒
      } else {
        return 15000; // 15秒
      }
    },
    queryPaymentStatus() {
      if (Date.now() - this.pollingStartTime > this.maxPollingTime) {
        this.stopPolling();
        console.log('轮询超时，停止查询支付状态');
        return;
      }
      this.pollingCount += 1;
      const key = this.$route.query.key;
      getStatus(key).then((res) => {
        if (res.respCode === '20000' && res.data) {
          const { status } = res.data;
          if (status === 'S') {
            this.stopPolling();
            this.handlePaymentSuccess(res.data);
          } else if (status === 'F') {
            this.stopPolling();
            this.handlePaymentFailed(res.data?.reason || res.respMsg || '', res.data);
          } else if (status === 'P' || status === 'R') {
            this.scheduleNextPolling();
          }
        } else {
          this.handlePaymentFailed(res.respMsg);
          this.stopPolling();
        }
      }).catch((error) => {
        console.error('查询支付状态失败:', error);
        this.scheduleNextPolling();
      });
    },
    scheduleNextPolling() {
      if (!this.isPollingActive) return;
      const interval = this.getPollingInterval();
      this.pollingTimer = setTimeout(() => {
        this.queryPaymentStatus();
      }, interval);
    },
    handlePaymentSuccess(data) {
      if (this.isMobile) {
        this.resultPopup = {
          visible: true,
          popupStatus: 'success', // success
          popupTitle: this.$t('message.result.success'),
          popupText: `${this.$t('message.result.successPop')}`,
          redirectUrl: data.returnUrl,
          billingAddress: data.billingAddress,
        };
      } else {
        this.successModalInfo.modelValue = true;
        this.successModalInfo.redirectUrl = data.returnUrl;
        this.successModalInfo.billingAddress = data.billingAddress;
      }
    },
    handlePaymentFailed(errorMsg, data) {
      if (this.isMobile) {
        this.resultPopup = {
          visible: true,
          popupStatus: 'failed', // success
          popupTitle: this.$t('message.result.failed'),
          popupText: `${this.$t('message.result.reason')}: ${errorMsg || ''}`,
          redirectUrl: data?.returnUrl,
          billingAddress: data?.billingAddress,
        };
      } else {
        this.errorModalInfo.modelValue = true;
        this.errorModalInfo.description = errorMsg;
        this.errorModalInfo.redirectUrl = data?.returnUrl;
      }
    },
  },
  computed: {
    isMobile: () => {
      // 通过设备判断
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    },
  },

};
</script>
<style lang="scss" scoped>
*{
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
}
.local-wrapper {
  height: 100vh;
  background-color: #fff;
}

.payment-container {
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  gap: 110px;
  justify-content: center;
}

.left-section {
  flex: 1;
  max-width: 366px;
  margin-top: 90px;
}

.right-section {
  flex: 1;
  padding-top: 90px;
  padding-left: 110px;
  background: #FFFFFF;
  position: relative;
  box-shadow: -10px 0px 20px 0px rgba(0, 0, 0, 0.102);

  height: 100%;
  .content{
    max-width: 406px;
    border-radius: 8px;
    border: 1px solid rgba(24, 32, 88, 0.1);
    padding: 24px;
    background: #FFFFFF;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    .validity-section{
      .scan-title {
        font-family: 'Open Sans-regular';
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0px;
        color: #1A202C;
        }
        .validity-badge {
          font-family: 'Open Sans-regular';
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0px;
          color: #182058;
        }
    }
  }
}

.payment-method {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid #C9CDD4;
  padding-bottom: 23px;
}

.payment-method-label {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #667085;
}

.payment-logo {
  height: 32px;
  width: auto;
}

.payment-logo-placeholder {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #3b82f6;
  padding: 8px 16px;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.validity-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 16px 0;
}

.validity-icon {
  font-size: 14px;
}

.validity-text {
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #3b82f6;
}

.qr-section {
  text-align: center;
}

.warning-info{
  font-family: 'Open Sans-regular';
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: #F53F3F;
  margin:16px 0;
}
.qr-code-container {
  display: flex;
  justify-content: center;
  align-content: center;
}
.ticket-item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    gap: 10px;

    .button {
      padding: 0;

      .icon-rongqi {
        font-size: 20px;
        color: var(--color-primary);
      }
    }
  }

.qr-code-image {
  width: 300px;
  height: 300px;
  object-fit: contain;
}
.download-btn {
  position: relative;
  width: 100%;
  height: 44px;
  border-radius: 8px;
  padding: 8px 24px;
  background: #182058;
  color: #fff;
  font-family: 'Open Sans-regular';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon-down{
    position: absolute;
    top: 12px;
    right: 12px;
    width: 14px;
    height: 14px;
  }
  // &:hover {
  //   transform: translateY(-1px);
  //   box-shadow: 0 4px 12px rgba(59, 77, 102, 0.3);
  // }

  // &:active {
  //   transform: translateY(0);
  // }
}

.download-icon {
  font-size: 16px;
}

.error-msg {
  text-align: center;
  padding: 100px 20px;
  max-width: 600px;
  margin: 0 auto;

  .unknow {
    width: 120px;
    height: auto;
    margin-bottom: 24px;
  }

  .tips {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #667085;
    line-height: 24px;
  }
}

// 移动端响应式
@media screen and (max-width: 768px) {
  .local-wrapper {
    background-color: #F9FAFB;
    padding: 16px;
    overflow-x: hidden;
  }
  .payment-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
  }

  .left-section,
  .right-section {
    background: #fff;
    max-width: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    flex: 0;

  }
  .left-section{
    // padding: 16px 16px 0;
    .product-content{
      padding: 0;
    }
    .order-summary{
      padding: 0;
    }
  }
  .right-section {
    box-shadow: none;
    .content{
      padding: 16px;
    }
  }
  .payment-method {
    margin-bottom: 20px;
  }

  .payment-method-label {
    font-size: 13px;
  }

  .payment-logo {
    height: 28px;
  }

  .payment-logo-placeholder {
    font-size: 14px;
    padding: 6px 12px;
  }

  .validity-section {
    margin-bottom: 24px;
  }

  .validity-text {
    font-size: 13px;
  }

  .scan-title {
    font-size: 18px;
    // margin-bottom: 14px;
  }

  .warning-info {
    line-height: 18px;
    font-size: 13px;
    margin-bottom: 8px;
  }

  .qr-code-image {
    width: 220px;
    height: 220px;
  }

  .download-btn {
    padding: 14px 28px;
    font-size: 15px;
    min-width: 140px;
  }
}
</style>
<style lang="scss">
.left-section{
  .order-summary{
    padding: 0;
    .product-content{
      padding: 0;
    }
  }
}
.local-wrapper{
  .el-button--text{
    color: #182058;
  }
}

</style>
